import { Card } from "antd"
import Image from "next/image"
const { Meta } = Card
type CustomCardProps = {
  img: string
  alt: string
  title: string
  description: string
}
const CustomCard: React.FC<CustomCardProps> = ({
  img,
  alt,
  title,
  description,
}) => (
  <Card
    hoverable
    style={{ width: 340, marginBottom: "3%" }}
    cover={<Image alt={alt} src={img} height={260} width={347} />}
  >
    <Meta description={description} title={title} style={{ color: "purple" }} />
  </Card>
)

export default CustomCard
